import React, { useState } from 'react';
import { authApi } from '../api/client';
import logo from '../logo.svg';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await authApi.login(email.trim().toLowerCase(), password);
      localStorage.setItem('token', res.data.access_token);
      onLogin();
    } catch (err) {
      setError('Onjuist e-mailadres of wachtwoord');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <form className="login-card" onSubmit={handleSubmit}>
        <img src={logo} alt="Ergens Onderweg" className="login-logo" />
        <h1>look2book</h1>

        {error && <div className="message error">{error}</div>}

        <div className="form-group">
          <label>E-mail</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            autoFocus
            required
          />
        </div>

        <div className="form-group">
          <label>Wachtwoord</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        <button type="submit" disabled={loading}>
          {loading ? 'Bezig…' : 'Inloggen'}
        </button>
      </form>
    </div>
  );
}

export default Login;
